import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { authenticatedRouter } from './routes';
import * as AuthActions from './state/actions/creators/auth.actioncreator';
import packageJson from '../package.json';


class App extends React.PureComponent {
  state = {
    collapsed: false,
  };

  constructor(...args) {
    super(...args);
    const username = 'qcadmin';
    const password = 'mvva';
    const dominio = 'local';

    // this.props.setToken(localStorage.getItem('token'));
    // setToken(localStorage.getItem('token'));
    // const {loginActions} = AuthActions;
    // loginAction({ authStatus: null }, { AUTH_SUCCESS, login });
  }


  componentWillUnmount() {
    localStorage.clear();
  }

  componentDidMount() {
    let { token } = this.props;
    token = localStorage.getItem('token');

    // localStorage.setItem('token', 'OTkyYmUzNDFlNDc2N2YxNjc3OTEyYTc2NjRlZWJmZjE3OTUyNDdmZmI4YmNmYzllYzAyMDMxMDUzYTIyNDk5Mw'); // token);
    document.title = `QualitasApp - ${packageJson.version}`;
  }

  toggle = () => {
    const { collapsed } = this.state;
    this.setState({
      collapsed: !collapsed,
    });
  };

  render() {
    const { history } = this.props;

    return (
      authenticatedRouter({ history })
    );
  }
}

/* eslint react/forbid-prop-types: 0 */
App.propTypes = {
  token: PropTypes.string,
  history: PropTypes.object.isRequired,
};

App.defaultProps = {
  token: '',
};

const mapStateToProps = ({ auth, navigation }) => ({
  token: auth.token,
  navigation,
  AuthActions,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...AuthActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
